var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStationSubwayWaltti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5C0 1.567 1.567 0 3.5 0H24.5C26.433 0 28 1.567 28 3.5V24.5C28 26.433 26.433 28 24.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0571 10.8623V10.2664C20.0571 10.2312 20.1265 10.1962 20.1959 10.1962V24.5H24.5V3.5H18.148L14.1562 17.8389L14.0868 18.8205H13.9827L13.8785 17.8389L9.88679 3.5H3.5V24.5H7.87359V10.1962C7.90827 10.1962 7.97762 10.2312 7.97762 10.2664V10.8623L11.8653 24.5H16.1348L20.0571 10.8623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationSubwayWaltti);
export default __webpack_public_path__ + "static/media/station-subway-waltti.dddf60a822230999cd9d42ed2d243133.svg";
export { ForwardRef as ReactComponent };